import { Navigate } from 'react-router-dom';
import { useStore } from '../context';
import { UserTypeAll } from '../types';
import { showToRoles } from '../utils';

interface RoleGuardProps {
  roles: Array<UserTypeAll> | 'admin' | 'client';
  children: any;
}

export const RoleGuard = ({ roles, children }: RoleGuardProps) => {
  const {
    state: {
      user: { data: user },
    },
  } = useStore();

  if (showToRoles(roles, user)) {
    return children;
  }

  return <Navigate to={'/dashboard'} replace />;
};
